import React from 'react';
import { useTranslation } from 'react-i18next';
import { Box, Button, ButtonSize, PagePanel } from 'edenred-ui';

import { ICardOrderSuccessfulScreen } from '@epi-models/containers/OrderStatus';
import { useMenuDimensions } from '@epi-shared/hooks';

import { PaymentMethods } from '../../constants/paymentMethods';
import { routerPaths } from '../../constants/routerPaths';
import { DownloadInvoiceButton } from '../../components/DownloadInvoiceButton/DownloadInvoiceButton';

export function CardOrderSuccessfulScreen({
  isPaymentSuccess,
  getTranslationPath,
  paymentMethod,
  paymentId,
  isReceiptOnly,
  goToPage
}: ICardOrderSuccessfulScreen) {
  const { t } = useTranslation();
  const { isMobile } = useMenuDimensions();

  return (
    <PagePanel title={t(getTranslationPath('title_success', isPaymentSuccess))}>
      <h2
        className="small"
        dangerouslySetInnerHTML={{
          __html: t(getTranslationPath('body_success', isPaymentSuccess))
        }}
      />
      {paymentMethod === PaymentMethods.PrintInvoicePdf && (
        <h2 className="small">
          {t('containers.order_status.body_reference_number_info')}
        </h2>
      )}
      <Box
        display="flex"
        flexDirection={isMobile ? 'column' : 'row'}
        gap={3}
        mt={3}
      >
        <div>
          <DownloadInvoiceButton
            id={paymentId}
            idType="payment"
            className="btn-download"
          >
            <span>
              {isReceiptOnly
                ? t('containers.order_status.download_receipt')
                : t('containers.order_status.download_invoice')}
            </span>
          </DownloadInvoiceButton>
        </div>
        <Button
          id="go-to-transactions-history-btn"
          size={ButtonSize.Medium}
          onClick={() => goToPage(`${routerPaths.transactionsHistory}`)}
        >
          {t(getTranslationPath('button_success'))}
        </Button>
      </Box>
    </PagePanel>
  );
}
